import React, { useCallback } from "react";
import styles from "./dropzone.module.scss";
import { useDropzone } from "react-dropzone";
import { IFileFromInput, setUploads } from "../../ducks/upload";
import CancelIcon from "@mui/icons-material/Cancel";
import { useSelector } from "react-redux";
import { selectUploadFiles } from "../../selectors/upload";
import { getStoreUtils } from "../../store/utils";
import {
  CloseIconButton,
  FileIcon,
  FileName,
} from "../uploadPopup/file-list/styles";

export interface IDropzoneProps {
  isEmpty?: boolean;
  files: IFileFromInput[];
  setFiles: (files: IFileFromInput[]) => void;
  onDropHandler: (params: any) => void;
}

export default function MyDropzone(props: IDropzoneProps) {
  const onDrop = useCallback(props.onDropHandler, []);
  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    noDrag: true,
    accept: {
      "image/jpeg": [".jpg", ".jpeg", ".JPG", ".JPEG"],
      "image/png": [".png", ".PNG"],
      "image/tiff": [".tiff", ".tif", ".TIFF", ".TIF"],
      "application/pdf": [".pdf", ".PDF"],
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [
        ".xls",
        ".xlsx",
        ".XLS",
        ".XLSX",
      ],
      "application/msword": [".doc", ".DOC"],
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
        [".docx", ".DOCX"],
    },
  });

  const files = useSelector(selectUploadFiles);
  const { dispatch } = getStoreUtils();

  return (
    <div className={`${styles.dropZone}`} {...getRootProps()}>
      <input {...getInputProps()} />
      {props.isEmpty ? (
        <>
          <div className={styles.dropZoneTitle}>
            Загрузите акты сверки для поиска расхождений
          </div>
          <div className={`${styles.uploadTextContainer} ${styles.marginZero}`}>
            <div className={styles.dropZoneLabel}>
              Кликните сюда для загрузки файлов
            </div>
            <div className={styles.dropZoneLabel}>
              или перетащите файлы сюда
            </div>
          </div>
          <div className={styles.imageIcon} />
          <div className={styles.dropZoneFooter}>
            Поддерживаются следующие файлы: PDF, DOCX, DOC, XLSX, XLS, JPG, TIFF, PNG
          </div>
        </>
      ) : (
        <div className={styles.notEmptyContainer}>
          <div className={styles.filesContainer}>
            {files.map(({ fileName, id }) => (
              <div className={styles.fileContainer} key={id}>
                <FileIcon />
                <FileName>{fileName}</FileName>
                <div className={styles.closeBtn}>
                  <CloseIconButton
                    onClick={(e) => {
                      e.stopPropagation();
                      dispatch(
                        setUploads(files.filter((file) => file.id !== id))
                      );
                    }}
                  >
                    <CancelIcon />
                  </CloseIconButton>
                </div>
              </div>
            ))}
          </div>
          <div className={styles.footer}>
            <div className={styles.smallLabel}>
              Отправьте документы на обработку
            </div>
            <div className={styles.smallLabel}>или загрузите еще</div>
          </div>
        </div>
      )}
    </div>
  );
}
